import _groupBy from 'lodash.groupby';
import RegenerateAllIvrMessagesForm from '../RegenerateAllIvrMessagesForm';
import IvrBasicMessagesMaincConfig from './IvrBasicMessagesMainConfig';
import IvrBasicMessagesList from './IvrBasicMessagesList';

// @vue/component
export default {
  name: 'IvrBasicMessages',

  components: {
    IvrBasicMessagesMaincConfig,
    IvrBasicMessagesList,
    RegenerateAllIvrMessagesForm,
  },

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isModalVisible: false,
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/ivrBasicMessages/getDetails', 'global/dictionaries/getPollyConfigList',
        'client/project/ivrBasicMessages/updateIvrMessages',
      ]);
    },
    ivrBasicMessages() {
      return this.$store.getters['client/project/ivrBasicMessages/details'];
    },
    pollyConfigDictionary() {
      const config = this.$store.getters['global/dictionaries/pollyConfigList'];
      return _groupBy(config, 'category');
    },
  },

  created() {
    this.$store.dispatch('client/project/ivrBasicMessages/getDetails', this.projectUuid);
    this.$store.dispatch('global/dictionaries/getPollyConfigList');
    this.$EventBus.$on('IvrBasicMessagesMainConfig/OPEN_REGENERATE_IVR_MESSAGES_FORM', () => {
      this.isModalVisible = true;
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('IvrBasicMessagesMainConfig/OPEN_REGENERATE_IVR_MESSAGES_FORM');
  },
};
